import type {
  QuestionData,
  QuestionOption,
  QuestionOptionTranslationData,
  QuestionTranslationData,
} from 'src/types/formQuestionnaire';
import { DEFAULT_FORM_EDITING_LOCALE } from './localizedQuestionFieldHelpers';

function keepDefaultLocaleQuestionTranslationsOnly(
  translations: QuestionTranslationData[] | undefined,
): QuestionTranslationData[] | undefined {
  if (!translations?.length) {
    return undefined;
  }
  const kept = translations.filter(
    (t) => t.languageCode === DEFAULT_FORM_EDITING_LOCALE,
  );
  return kept.length ? kept : undefined;
}

function keepDefaultLocaleOptionTranslationsOnly(
  translations: QuestionOptionTranslationData[] | undefined,
): QuestionOptionTranslationData[] | undefined {
  if (!translations?.length) {
    return undefined;
  }
  const kept = translations.filter(
    (t) => t.languageCode === DEFAULT_FORM_EDITING_LOCALE,
  );
  return kept.length ? kept : undefined;
}

function stripOptionTranslations(opt: QuestionOption): QuestionOption {
  const nextTranslations = keepDefaultLocaleOptionTranslationsOnly(
    opt.translations,
  );
  const { translations: _removed, ...rest } = opt;
  return nextTranslations?.length
    ? { ...rest, translations: nextTranslations }
    : rest;
}

export function stripFormNonDefaultQuestionTranslationsForDuplicate(
  questions: QuestionData[],
): QuestionData[] {
  return questions.map((q) => {
    const nextQuestionTranslations = keepDefaultLocaleQuestionTranslationsOnly(
      q.translations,
    );
    const nextOptions = q.options?.map(stripOptionTranslations);

    const { translations: _qt, options: _qo, ...rest } = q;

    return {
      ...rest,
      ...(nextQuestionTranslations?.length && {
        translations: nextQuestionTranslations,
      }),
      ...(nextOptions && { options: nextOptions }),
    };
  });
}
